import { alertService } from './alertService';

export default alertService;
